import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type EpisodeFragment = {
	__typename?: 'Episode';
	id: string;
	objectId: number;
	objectType: Types.ObjectType;
	uniqueOfferCount: number;
	seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
	flatrate: Array<{
		__typename?: 'Offer';
		id: string;
		package: { __typename?: 'Package'; id: string; clearName: string; packageId: number };
	}>;
	buy: Array<{
		__typename?: 'Offer';
		id: string;
		package: { __typename?: 'Package'; id: string; clearName: string; packageId: number };
	}>;
	rent: Array<{
		__typename?: 'Offer';
		id: string;
		package: { __typename?: 'Package'; id: string; clearName: string; packageId: number };
	}>;
	free: Array<{
		__typename?: 'Offer';
		id: string;
		package: { __typename?: 'Package'; id: string; clearName: string; packageId: number };
	}>;
	linear: Array<{
		__typename?: 'Offer';
		id: string;
		package: { __typename?: 'Package'; id: string; clearName: string; packageId: number };
	}>;
	content: {
		__typename: 'EpisodeContent';
		title: string;
		shortDescription?: string | null;
		episodeNumber: number;
		seasonNumber: number;
		isReleasedV2: boolean;
		runtime?: number | null;
		upcomingReleases: Array<{
			__typename?: 'UpcomingRelease';
			releaseCountDown?: number | null;
			releaseDate?: any | null;
			releaseType: Types.ReleaseType;
			label: Types.UpcomingReleaseLabel;
			package?: {
				__typename?: 'Package';
				id: string;
				packageId: number;
				shortName: string;
				clearName: string;
				monetizationTypes: Array<Types.MonetizationType>;
				icon: string;
				iconWide: string;
				hasRectangularIcon: boolean;
				planOffers: Array<{
					__typename?: 'PackagePlanOffer';
					retailPrice?: string | null;
					durationDays?: number | null;
					presentationType?: Types.PresentationType | null;
					isTrial?: boolean | null;
					retailPriceValue?: number | null;
					currency?: string | null;
				}>;
			} | null;
		}>;
	};
};

export const EpisodeFragmentDoc = gql`
	fragment Episode on Episode {
		id
		objectId
		objectType
		seenlistEntry {
			createdAt
		}
		uniqueOfferCount: offerCount(country: $country, platform: $platform, filter: { bestOnly: true })
		flatrate: offers(
			country: $country
			platform: $platform
			filter: {
				monetizationTypes: [FLATRATE_AND_BUY, FLATRATE, ADS, CINEMA, FREE]
				bestOnly: true
				preAffiliate: true
			}
		) {
			id
			package {
				id
				clearName
				packageId
			}
		}
		buy: offers(
			country: $country
			platform: $platform
			filter: { monetizationTypes: [BUY], bestOnly: true, preAffiliate: true }
		) {
			id
			package {
				id
				clearName
				packageId
			}
		}
		rent: offers(
			country: $country
			platform: $platform
			filter: { monetizationTypes: [RENT], bestOnly: true, preAffiliate: true }
		) {
			id
			package {
				id
				clearName
				packageId
			}
		}
		free: offers(
			country: $country
			platform: $platform
			filter: { monetizationTypes: [ADS, FREE], bestOnly: true, preAffiliate: true }
		) {
			id
			package {
				id
				clearName
				packageId
			}
		}
		linear: offers(
			country: $country
			platform: $platform
			filter: { monetizationTypes: [FAST], bestOnly: true, preAffiliate: true }
		) {
			id
			package {
				id
				clearName
				packageId
			}
		}
		content(country: $country, language: $language) {
			__typename
			title
			shortDescription
			episodeNumber
			seasonNumber
			isReleasedV2(country: $country)
			runtime
			upcomingReleases {
				releaseCountDown(country: $country)
				releaseDate
				releaseType
				label
				package {
					id
					packageId
					shortName
					clearName
					monetizationTypes
					icon(profile: S100)
					iconWide(profile: S160)
					hasRectangularIcon(country: $country, platform: WEB)
					planOffers(country: $country, platform: $platform) {
						retailPrice(language: $language)
						durationDays
						presentationType
						isTrial
						retailPriceValue
						currency
					}
				}
			}
		}
	}
`;
